<template>
  <div>
    <el-button
      v-btnAuth="{ menuCode: 'daily-discount', btnCode: '新建' }"
      type="primary"
      @click="newSetting"
      >新建折扣设置</el-button
    >
    <el-button
      v-btnAuth="{ menuCode: 'daily-discount', btnCode: '新建' }"
      @click="downloadZip"
      >下载所有查询结果</el-button
    >
    <el-button type="primary" @click="showSkuForm">特殊SKU折扣设置</el-button>

    <el-table class="myTable" :data="tableData">
      <el-table-column prop="categoryType" label="类目">
        <template slot-scope="scope">
          {{ scope.row.categoryType == 1 ? "Adult" : "Kids" }}
        </template>
      </el-table-column>
      <el-table-column :label="'季节' + (isCo ? `(是否CO)` : '')">
        <template slot-scope="scope">
          {{ scope.row.seasonCode }}{{ scope.row.coFlag === 1 ? "(CO)" : "" }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{
            scope.row.status
              ? scope.row.status == 1
                ? "待生效"
                : "已生效"
              : "-"
          }}<span v-if="scope.row.runStatus == 2">(价格计算中)</span>
        </template>
      </el-table-column>
      <el-table-column prop="validFrom" label="生效时间">
        <template slot-scope="scope">
          <span v-if="scope.row.validFrom">
            {{
              new Date(scope.row.validFrom).toLocaleString().replace(/\//g, "-")
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="validFrom" label="失效时间">
        <template slot-scope="scope">
          <span v-if="scope.row.nextValidDate">
            {{
              new Date(scope.row.nextValidDate)
                .toLocaleString()
                .replace(/\//g, "-")
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="operatorUserName"
        label="最后更新人"
      ></el-table-column>
      <el-table-column prop="updateAt" label="最后更新时间">
        <template slot-scope="scope">
          <span v-if="scope.row.updateAt">
            {{
              new Date(scope.row.updateAt).toLocaleString().replace(/\//g, "-")
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="230" prop="">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 1 || scope.row.status === 2"
            type="text"
            @click="check(scope.row)"
            >查看</el-button
          >
          <el-button
            v-btnAuth="{ menuCode: 'daily-discount', btnCode: '下载' }"
            v-if="scope.row.status === 1 || scope.row.status === 2"
            type="text"
            @click="downloadTemplate(scope.row.priceChangeRuleId)"
            >下载</el-button
          >
          <el-button
            v-btnAuth="{ menuCode: 'daily-discount', btnCode: '复制-季节' }"
            @click="copyDialog(scope.row)"
            type="text"
            >复制</el-button
          >
          <el-button
            v-btnAuth="{ menuCode: 'daily-discount', btnCode: '编辑' }"
            @click="showDialog(scope.row)"
            v-if="scope.row.status === 1"
            type="text"
            >编辑</el-button
          >
          <el-button
            v-btnAuth="{ menuCode: 'daily-discount', btnCode: '删除' }"
            v-if="scope.row.status === 1"
            @click="removeItem(scope.row.priceChangeRuleId)"
            type="text"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: right; margin: 20px 0"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[15, 25, 30, 50]"
      :page-size="pageSize"
      layout="total, prev, pager, next,sizes, jumper"
      :total="total"
    ></el-pagination>
    <!-- 新建 -->
    <el-dialog
      title="新建折扣设置"
      :visible.sync="createDialogVisible1"
      width="400px"
    >
      <el-radio-group v-model="createType">
        <el-radio :label="1" class="mb20"
          >当前季节首次生效（无需折扣比对）</el-radio
        >
        <el-radio :label="2">当前季节折扣更新（需折扣比对）</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createDialogVisible1 = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="!createType"
          @click="createNextStep"
          >下一步</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="新建折扣设置"
      :visible.sync="createDialogVisible2"
      width="900px"
    >
      <el-alert
        v-if="createType === 1"
        class="mb20"
        title="注：导入折扣采用全量方式进行覆盖"
        type="success"
      ></el-alert>
      <p class="tc" v-if="createType === 2">折扣对比</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="left"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="类目："
          prop="categoryType"
          @change="ruleForm.seasonCode = null"
        >
          <el-radio v-model="ruleForm.categoryType" :label="1">Adult</el-radio>
          <el-radio v-model="ruleForm.categoryType" :label="2">Kids</el-radio>
        </el-form-item>
        <el-form-item
          v-if="createType === 1"
          label="季节："
          prop="seasonCodeList"
        >
          <p>有生效中折扣的季节无法选择，必须比对后方可提交</p>
          <el-checkbox-group v-model="ruleForm.seasonCodeList">
            <template v-if="isCo">
              <p class="f14">Carry Over</p>
              <el-checkbox
                v-for="(item, index) in coSeasonList"
                :key="index"
                :label="item"
                :disabled="
                  (ruleForm.categoryType == 1 && item.adultEffectiveFlag) ||
                  (ruleForm.categoryType == 2 && item.kidsEffectiveFlag)
                "
              >
                {{ item.label
                }}<span
                  v-if="
                    (ruleForm.categoryType == 1 && item.adultPendingFlag) ||
                    (ruleForm.categoryType == 2 && item.kidsPendingFlag)
                  "
                >
                  (<span class="red">有待生效折扣</span>)</span
                >
              </el-checkbox>
              <p class="f14">非Carry Over</p>
              <el-checkbox
                v-for="(item, index) in seasonList"
                :key="index"
                :label="item"
                :disabled="
                  (ruleForm.categoryType == 1 && item.adultEffectiveFlag) ||
                  (ruleForm.categoryType == 2 && item.kidsEffectiveFlag)
                "
              >
                {{ item.label
                }}<span
                  v-if="
                    (ruleForm.categoryType == 1 && item.adultPendingFlag) ||
                    (ruleForm.categoryType == 2 && item.kidsPendingFlag)
                  "
                >
                  (<span class="red">有待生效折扣</span>)</span
                >
              </el-checkbox>
            </template>
            <template v-else>
              <el-checkbox
                v-for="(item, index) in seasonList"
                :key="index"
                :label="item"
                :disabled="
                  (ruleForm.categoryType == 1 && item.adultEffectiveFlag) ||
                  (ruleForm.categoryType == 2 && item.kidsEffectiveFlag)
                "
              >
                {{ item.label
                }}<span
                  v-if="
                    (ruleForm.categoryType == 1 && item.adultPendingFlag) ||
                    (ruleForm.categoryType == 2 && item.kidsPendingFlag)
                  "
                >
                  (<span class="red">有待生效折扣</span>)</span
                >
              </el-checkbox>
            </template>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="createType === 2" label="季节：" prop="seasonCode">
          <p>没有生效中折扣的季节无法选择</p>
          <el-radio-group v-model="ruleForm.seasonCode">
            <template v-if="isCo">
              <p class="f14 mb10">Carry Over</p>
              <el-radio
                class="mb10"
                v-for="(item, index) in coSeasonList"
                :key="index"
                :label="item"
                :disabled="
                  (ruleForm.categoryType == 1 && !item.adultEffectiveFlag) ||
                  (ruleForm.categoryType == 2 && !item.kidsEffectiveFlag)
                "
              >
                {{ item.label }}
              </el-radio>
              <p class="f14 mb10 mt10">非Carry Over</p>
              <el-radio
                class="mb10"
                v-for="(item, index) in seasonList"
                :key="index"
                :label="item"
                :disabled="
                  (ruleForm.categoryType == 1 && !item.adultEffectiveFlag) ||
                  (ruleForm.categoryType == 2 && !item.kidsEffectiveFlag)
                "
              >
                {{ item.label }}
              </el-radio>
            </template>
            <template v-else>
              <el-radio
                class="mb10"
                v-for="(item, index) in seasonList"
                :key="index"
                :label="item"
                :disabled="
                  (ruleForm.categoryType == 1 && !item.adultEffectiveFlag) ||
                  (ruleForm.categoryType == 2 && !item.kidsEffectiveFlag)
                "
              >
                {{ item.label }}
              </el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="生效时间："
          prop="validFrom"
          v-if="createType === 1"
        >
          <el-radio-group v-model="ruleForm.validFrom" class="flex">
            <el-radio label="1">指定时间生效</el-radio>
            <el-radio label="0">立即生效</el-radio>
          </el-radio-group>
          <el-date-picker
            class="absolute"
            :disabled="ruleForm.validFrom == 0"
            v-model="ruleForm.startTime"
            :picker-options="option"
            type="datetime"
            value-format="timestamp"
            @change="handle(0)"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="导入文件：" prop="fileName">
          <el-col :span="12">
            <div style="position: relative">
              <el-upload
                ref="upload"
                class="upload-demo"
                action=""
                :limit="1"
                :http-request="handleHttpRequest"
                :before-upload="beforeUpload"
                :on-success="submitSuccess"
                :on-remove="onRemove"
                :on-change="handleChange"
                :file-list="fileList"
                accept=".xls,.xlsx,.XLS,.XLSX"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  支持扩展名：.xls .xlxs
                </div>
              </el-upload>
              <el-link
                style="position: absolute; top: 0; left: 130px"
                type="primary"
                :underline="false"
                @click="downloadFile"
                >下载文件模板</el-link
              >
            </div>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">{{
          createType === 1 ? "确 定" : "下一步"
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="500px"
      title="新建折扣设置"
      :visible.sync="createDialogVisible3"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
    >
      <p class="big green" v-if="compareResult.success">比对成功</p>
      <p class="big red" v-else>
        {{ compareResult.code == "1304" ? "文件解析失败" : "比对失败" }}
      </p>
      <p v-if="compareResult.code == '1301'" class="tc primary">
        比对文件相同，请重新上传正确的文件
      </p>
      <p v-if="compareResult.code == '1302'" class="red tc">
        当前文件行数过多，仅比对二级，三级类目折扣
      </p>
      <p v-if="compareResult.code == '1303'" class="red tc">
        当前文件行数过多，仅比对二级类目折扣
      </p>
      <p v-if="compareResult.success" class="tc">
        <el-link type="primary" @click="downloadUrlFile(compareResult.analyUrl)"
          >下载文件对比结果</el-link
        >
      </p>
      <p
        v-if="compareResult.warmingPercentage"
        class="tc"
      >
        {{ compareResult.warmingPercentage }}
      </p>
      <p
        v-if="
          !compareResult.success && !compareResult.code && compareResult.message
        "
        class="tc"
      >
        {{ compareResult.message }}
      </p>
      <p
        v-if="
          !compareResult.success && compareResult.compareFailReason"
        class="tc"
      >
        {{ compareResult.compareFailReason }}
      </p>
      <p v-if="!compareResult.success && compareResult.analyUrl" class="tc">
        <el-link type="primary" @click="downloadUrlFile(compareResult.analyUrl)"
          >下载文件解析结果</el-link
        >（请根据错误原因更新文件后重新提交）
      </p>
      <div slot="footer">
        <el-button @click="resetForm('ruleForm')">关 闭</el-button>
        <el-button
          type="primary"
          v-if="!compareResult.success"
          @click="
            createDialogVisible3 = false;
            createDialogVisible2 = true;
          "
          >上一步</el-button
        >
        <el-button
          type="primary"
          v-if="
            compareResult.success ||
            compareResult.code == '1302' ||
            compareResult.code == '1303'
          "
          @click="createNextStep3"
          >下一步</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      width="900px"
      title="新建折扣设置"
      :visible.sync="createDialogVisible4"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-alert
        class="mb20"
        title="注：导入折扣采用全量方式进行覆盖"
        type="success"
      ></el-alert>
      <p class="tc">折扣提交</p>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm4"
        label-position="left"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="导入文件" v-if="fileList && fileList.length > 0">{{
          fileList[0].name
        }}</el-form-item>
        <el-form-item label="季节：" prop="seasonCodeList">
          <div style="display: flex; justify-content: center">
            <el-button
              type="primary"
              size="small"
              @click="checkAll4"
              style="margin-right: 20px"
              >全部选中</el-button
            >
            <el-button type="primary" size="small" @click="checkCancel4"
              >全部取消</el-button
            >
          </div>
          <el-checkbox-group v-model="ruleForm.seasonCodeList">
            <template v-if="isCo">
              <p class="f14">Carry Over</p>
              <el-checkbox
                v-for="(item, index) in coSeasonList"
                :key="index"
                :label="item"
              >
                {{ item.label }}
              </el-checkbox>
              <p class="f14">非Carry Over</p>
              <el-checkbox
                v-for="(item, index) in seasonList"
                :key="index"
                :label="item"
              >
                {{ item.label }}
              </el-checkbox>
            </template>
            <template v-else>
              <el-checkbox
                v-for="(item, index) in seasonList"
                :key="index"
                :label="item"
              >
                {{ item.label }}
              </el-checkbox>
            </template>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="生效时间：" prop="validFrom">
          <el-radio-group v-model="ruleForm.validFrom" class="flex">
            <el-radio label="1">指定时间生效</el-radio>
            <el-radio label="0">立即生效</el-radio>
          </el-radio-group>
          <el-date-picker
            class="absolute"
            :disabled="ruleForm.validFrom == 0"
            v-model="ruleForm.startTime"
            :picker-options="option"
            type="datetime"
            value-format="timestamp"
            @change="handle(0)"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间（选填）：">
          <el-date-picker
            class="absolute"
            v-model="ruleForm.nextValidDate"
            type="datetime"
            placeholder="选择失效时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            createDialogVisible4 = false;
            createDialogVisible2 = true;
          "
          >上一步</el-button
        >
        <el-button type="primary" @click="submitCompare">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog title="编辑" :visible.sync="dialogVisible1" width="50%">
      <p class="mb20">
        类目： {{ ruleForm1.categoryType == 1 ? "Adult" : "Kids" }}
        <span class="ml20"
          >季节：{{ ruleForm1.seasonCode
          }}{{ ruleForm1.coFlag === 1 ? "(CO)" : "" }}</span
        >
      </p>
      <el-form
        :model="ruleForm1"
        ref="ruleForm1"
        label-width="140px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item
          label="生效时间："
          prop="validFrom"
          :rules="[
            { required: true, message: '请选择生效时间', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="ruleForm1.validFrom" class="flex">
            <el-radio label="1">指定时间生效</el-radio>
            <el-radio label="0">立即生效</el-radio>
          </el-radio-group>
          <el-date-picker
            class="absolute"
            :disabled="ruleForm1.validFrom == 0"
            v-model="ruleForm1.startTime"
            :picker-options="option"
            type="datetime"
            @change="handle(1)"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间（选填）：">
          <el-date-picker
            class="absolute"
            v-model="ruleForm1.nextValidDate"
            type="datetime"
            placeholder="选择失效时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm1')">取 消</el-button>
        <el-button type="primary" @click="submitForm1('ruleForm1')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 复制 -->
    <el-dialog title="复制" :visible.sync="dialogVisible2" width="50%">
      <div>
        <el-form
          :model="ruleForm2"
          ref="ruleForm2"
          :rules="rules2"
          label-width="140px"
          label-position="left"
          class="demo-ruleForm"
        >
          <p style="padding: 0 0 20px 8px">
            类目： {{ ruleForm2.categoryType == 1 ? "Adult" : "Kids" }} 季节：{{
              ruleForm2.seasonCode
            }}{{ ruleForm2.coFlag === 1 ? "(CO)" : "" }}
          </p>
          <el-form-item label="季节：" prop="seasonCodeList">
            <div style="display: flex; justify-content: center">
              <el-button
                type="primary"
                size="small"
                @click="checkAll"
                style="margin-right: 20px"
                >全部选中</el-button
              >
              <el-button type="primary" size="small" @click="checkCancel"
                >全部取消</el-button
              >
            </div>
            <el-checkbox-group v-model="ruleForm2.seasonCodeList">
              <template v-if="isCo">
                <p class="f14">Carry Over</p>
                <template v-for="(item, index) in coSeasonList">
                  <el-checkbox
                    :key="index"
                    :label="item"
                    v-if="
                      !(
                        ruleForm2.seasonCode == item.value &&
                        ruleForm2.coFlag == 1
                      )
                    "
                  >
                    {{ item.label
                    }}<span
                      v-if="
                        (ruleForm2.categoryType == 1 &&
                          item.adultPendingFlag) ||
                        (ruleForm2.categoryType == 2 && item.kidsPendingFlag)
                      "
                    >
                      (<span class="red">有待生效折扣</span>)</span
                    >
                  </el-checkbox>
                </template>
                <p class="f14">非Carry Over</p>
                <template v-for="(item, index) in seasonList">
                  <el-checkbox
                    :key="index+'2'"
                    :label="item"
                    v-if="
                      !(
                        ruleForm2.seasonCode == item.value &&
                        ruleForm2.coFlag == 0
                      )
                    "
                  >
                    {{ item.label
                    }}<span
                      v-if="
                        (ruleForm2.categoryType == 1 &&
                          item.adultPendingFlag) ||
                        (ruleForm2.categoryType == 2 && item.kidsPendingFlag)
                      "
                    >
                      (<span class="red">有待生效折扣</span>)</span
                    >
                  </el-checkbox>
                </template>
              </template>
              <template v-else>
                <template v-for="(item, index) in seasonList">
                  <el-checkbox
                    :key="index"
                    :label="item"
                    v-if="ruleForm2.seasonCode != item.value"
                  >
                    {{ item.label
                    }}<span
                      v-if="
                        (ruleForm2.categoryType == 1 &&
                          item.adultPendingFlag) ||
                        (ruleForm2.categoryType == 2 && item.kidsPendingFlag)
                      "
                    >
                      (<span class="red">有待生效折扣</span>)</span
                    >
                  </el-checkbox>
                </template>
              </template>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="生效时间：" prop="validFrom">
            <el-radio-group v-model="ruleForm2.validFrom" class="flex">
              <el-radio label="1">指定时间生效</el-radio>
              <el-radio label="0">立即生效</el-radio>
            </el-radio-group>
            <el-date-picker
              class="absolute"
              :disabled="ruleForm2.validFrom == 0"
              v-model="ruleForm2.startTime"
              :picker-options="option"
              type="datetime"
              @change="handle(2)"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="失效时间（选填）：" prop="nextValidDate">
            <el-date-picker
              class="absolute"
              v-model="ruleForm2.nextValidDate"
              @input="changeNextValidDate"
              type="datetime"
              placeholder="选择失效时间"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm2')">取 消</el-button>
        <el-button type="primary" @click="submitForm2('ruleForm2')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      width="30%"
      title="上传"
      :visible.sync="innerSuccessVisible"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
    >
      <p class="big green">文件解析成功</p>
      <p style="text-align: center">
        <el-link type="primary" @click="downloadUrlFile(analyUrl)"
          >下载文件解析结果</el-link
        >
      </p>
      <div
        slot="footer"
        class="dialog-footer"
        style="display: flex; align-items: center; justify-content: center"
      >
        <el-button @click="innerSuccessVisible = false">关 闭</el-button>
        <el-button type="primary" @click="submitFile">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="30%"
      title="上传"
      :visible.sync="innerFailedVisible"
      center
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
    >
      <p class="big red">文件解析失败</p>
      <p style="text-align: center">
        <el-link type="primary" @click="downloadUrlFile(analyUrl)"
          >下载文件解析结果</el-link
        >（请根据错误原因更新文件后重新提交）
      </p>
      <div
        slot="footer"
        class="dialog-footer"
        style="display: flex; align-items: center; justify-content: center"
      >
        <el-button @click="innerFailedVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import Client from "@/utils/client.js";
import { downloadUrlFile } from "@/utils/functions";
import {
  diaryDisountList,
  getTemplateUrl,
  fileUpload,
  ruleDownload,
  delDiscount,
  ruleCreate,
  ruleUpdate,
  ruleCopy,
  analysis,
  compare,
  ruleBatchDownload,
  compareResult
} from "../../api.js";
export default {
  props: ["seasonList", "coSeasonList"],
  data() {
    return {
      subVendorIs: this.$route.query.subVendorIs,
      vendorName: this.$route.query.name,
      supplyPriceMethod: this.$route.query.supplyPriceMethod,
      analyUrl: "",
      innerSuccessVisible: false,
      innerFailedVisible: false,
      // 如果是开通CO区分季节的店铺，则季节分别按CO和非CO显示，不再有单独的CO季节
      //如果是未开通CO区分季节的店铺，则季节显示所有季节和CO
      isCo: false,
      currentPage: 1,
      pageSize: 15,
      tableData: [],
      total: 0,
      form: {},
      createDialogVisible1: false,
      createType: null,
      createDialogVisible2: false,
      ruleForm: {
        categoryType: 1,
        validFrom: null,
        startTime: null,
        nextValidDate: null,
        seasonCodeList: [],
        seasonCode: null,
        fileName: "",
      },
      createDialogVisible3: false,
      compareResult: {
        code: null,
        success: true,
        message: null,
        warmingPercentage: null,
        analyUrl: "",
        compareFailReason: null
      },
      createDialogVisible4: false,
      dialogVisible1: false,
      dialogVisible2: false,
      lastSearchData: {},
      exceleUrl: "",
      ruleForm1: {
        categoryType: "",
        seasonCode: "", //用于展示
        seasonCodes: [],
        priceChangeRuleId: "",
        validFrom: null,
        startTime: null,
        nextValidDate: null,
      },
      ruleForm2: {
        priceChangeRuleId: "",
        seasonCode: "", //用于展示
        coFlag: null,
        categoryType: null,
        validFrom: null,
        startTime: null,
        seasonCodeList: [],
        nextValidDate: null
      },
      rules: {
        categoryType: [
          { required: true, message: "请选择类目", trigger: "change" },
        ],
        validFrom: [
          { required: true, message: "请选择生效时间", trigger: "change" },
        ],
        fileName: [
          { required: true, message: "请上传文件", trigger: "change" },
        ],
        seasonCodeList: [
          { required: true, message: "请选择季节", trigger: "change" },
        ],
        seasonCode: [
          { required: true, message: "请选择季节", trigger: "change" },
        ],
      },
      rules2: {
        validFrom: [
          { required: true, message: "请选择生效时间", trigger: "change" },
        ],
        seasonCodeList: [
          { required: true, message: "请选择季节", trigger: "change" },
        ],
      },
      option: {
        disabledDate: (validFrom) => {
          return validFrom.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
        },
      },
      fileList: [],
      copySeasonList: [],
      copyCoSeasonList: [],
    };
  },
  created() {
    const { id, name, co, supplyPriceMethod } = this.$route.query;
    this.id = id;
    this.name = name;
    this.supplyPriceMethod = supplyPriceMethod
    this.isCo = co == "false" ? false : true;
  },
  methods: {
    changeNextValidDate(){
      let _this = this
      _this.$nextTick(() => {
        _this.$forceUpdate()
      })
    },
    checkAll() {
      this.$nextTick(() => {
        let seasonCodeList = [];
        if (this.isCo) {
          this.coSeasonList.map((item) => {
            if (
              !(
                this.ruleForm2.seasonCode == item.value &&
                this.ruleForm2.coFlag == 1
              )
            ) {
              seasonCodeList.push(item);
            }
          });
          this.seasonList.map((item) => {
            if (
              !(
                this.ruleForm2.seasonCode != item.value &&
                this.ruleForm2.coFlag == 0
              )
            ) {
              seasonCodeList.push(item);
            }
          });
        } else {
          this.seasonList.map((item) => {
            if (this.ruleForm2.seasonCode != item.value) {
              seasonCodeList.push(item);
            }
          });
        }
        console.log(seasonCodeList);
        this.ruleForm2.seasonCodeList = seasonCodeList;
      });
    },
    checkCancel() {
      this.$nextTick(() => {
        this.ruleForm2.seasonCodeList = [];
      });
    },
    checkAll4() {
      this.$nextTick(() => {
        let seasonCodeList = [];
        if (this.isCo) {
          this.coSeasonList.map((item) => {
            seasonCodeList.push(item);
          });
          this.seasonList.map((item) => {
            seasonCodeList.push(item);
          });
        } else {
          this.seasonList.map((item) => {
            seasonCodeList.push(item);
          });
        }
        this.ruleForm.seasonCodeList = seasonCodeList;
      });
    },
    checkCancel4() {
      this.$nextTick(() => {
        this.ruleForm.seasonCodeList = [];
      });
    },
    async downloadZip() {
      // 如果当前查询结果没有任何折扣，则不能点击
      if (this.tableData.length === 0) return;
      try {
        this.$store.commit("setPageLoading", true);
        delete this.lastSearchData["pageNo"];
        delete this.lastSearchData["pageSize"];
        delete this.lastSearchData["isReset"];
        const resData = await ruleBatchDownload(this.lastSearchData);
        const blob = resData.data;
        const content = resData.headers["content-disposition"];
        let fileName = "file";
        if (content) {
          fileName = content.substring(content.indexOf("=") + 1);
        }
        this.downModel(blob, fileName);
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        this.$message.error("请求异常");
        this.$store.commit("setPageLoading", false);
      }
    },
    async handleHttpRequest(option) {
      try {
        this.$store.commit("setPageLoading", true);
        const dataObj = (await fileUpload()).data;
        const client = Client(dataObj),
          file = option.file;
        const random_name =
          "tmp/" +
          this.random_string(6) +
          "_" +
          new Date().getTime() +
          "." +
          file.name.split(".").pop();
        await client
          .put(random_name, file)
          .then(({ res }) => {
            if (res.statusCode === 200) {
              this.ruleForm.fileName = res.requestUrls[0];
            } else {
              option.onError("上传失败");
            }
          })
          .catch((error) => {
            console.log(error);
            option.onError("上传失败");
          });
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        this.$store.commit("setPageLoading", false);
        console.log(error);
        option.onError("上传失败");
      }
    },
    beforeUpload(file) {
      this.uploadFileName = file.name;
    },
    onRemove(file, fileList) {
      this.upFiles = fileList;
      this.ruleForm.fileName = "";
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    submitSuccess() {
      this.$refs.ruleForm.clearValidate("fileName");
    },
    async downloadTemplate(id) {
      this.$store.commit("setPageLoading", true);
      const resData = await ruleDownload(id);
      if (resData.data && resData.data.data) {
        downloadUrlFile(resData.data.data);
      }
      this.$store.commit("setPageLoading", false);
    },
    downFile(url) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      document.body.appendChild(iframe);
      iframe.src = url;
    },
    removeItem(id) {
      this.$confirm("确认删除当前折扣设置?", "提示", {
        confirmButtonText: "确定",
        closeOnClickModal: false,
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.$store.commit("setPageLoading", true);
          const res = await delDiscount(id);
          if (res.success) {
            this.$message.success("删除成功");
            this.resetQuery();
            this.$store.commit("setPageLoading", false);
          } else {
            this.$message.error(`${res.message}`);
            this.$store.commit("setPageLoading", false);
          }
        })
        .catch((e) => {
          this.$message({
            type: "info",
            message: `error: ${e}`,
          });
        });
    },
    newSetting() {
      //新建
      this.createType = null;
      this.createDialogVisible1 = true;
      this.$parent.init();
    },
    createNextStep() {
      this.createDialogVisible1 = false;

      this.ruleForm.categoryType = 1;
      this.ruleForm.validFrom = null;
      this.ruleForm.seasonCodeList = [];
      this.ruleForm.seasonCode = null;
      this.ruleForm.fileName = "";
      this.fileList = [];
      this.createDialogVisible2 = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    showDialog(data) {
      //编辑 仅允许修改生效时间
      this.dialogVisible1 = true;
      this.ruleForm1 = {
        ...data,
        validFrom: data.validFrom == 0 ? "0" : "1",
        startTime: data.validFrom == 0 ? null : data.validFrom,
        nextValidDate: data.nextValidDate,
      };
    },
    copyDialog(data) {
      //复制 去掉当前季节（不能复制自身）
      this.dialogVisible2 = true;

      this.ruleForm2.priceChangeRuleId = data.priceChangeRuleId;
      this.ruleForm2.seasonCode = data.seasonCode;
      this.ruleForm2.categoryType = data.categoryType;
      this.ruleForm2.coFlag = data.coFlag;
      this.ruleForm2.seasonCodeList = [];
      this.ruleForm2.validFrom = null;
      this.ruleForm2.startTime = null;
      this.ruleForm2.nextValidDate = null;
      this.$parent.init();
    },
    handleClose() {
      this.createDialogVisible1 = false;
      this.createDialogVisible2 = false;
      this.createDialogVisible3 = false;
      this.dialogVisible1 = false;
      this.dialogVisible2 = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.handleClose();
    },
    check(data) {
      //查看
      const { priceChangeRuleId, status, categoryType, seasonCode, coFlag } =
        data;
      let routeData = this.$router.resolve({
        path: "/discount/detail/daily",
        query: {
          id: priceChangeRuleId,
          status,
          categoryType,
          season: seasonCode,
          name: this.name,
          co: coFlag,
          page: "daily",
          supplyPriceMethod: this.supplyPriceMethod
        },
      });
      window.open(routeData.href, "_blank");
    },
    checkFileName() {
      const arr = this.uploadFileName.split("#").map((item) => {
        const temp = item.trim();
        return temp.toUpperCase();
      });
      if (arr[2]) {
        arr[2] = arr[2].replace("（", "(");
        arr[2] = arr[2].replace("）", ")");
      }
      if (arr[0] != this.vendorName.toUpperCase()) {
        this.$message.error(
          "上传文件的店铺名称与当前实际操作的店铺名称不一致，请修改后上传"
        );
        return false;
      }
      if (this.ruleForm.seasonCodeList.length === 1) {
        let seasonCode = this.ruleForm.seasonCodeList[0].value.toUpperCase();
        if (this.ruleForm.seasonCodeList[0].coFlag) {
          seasonCode += "(CO)";
        }
        if (!arr[2] || seasonCode != arr[2]) {
          this.$message.error(
            "上传文件的季节与当前实际操作的季节不一致，请修改后上传"
          );
          return false;
        }
      }
      return true;
    },
    submitForm(formName) {
      this.ruleForm.nextValidDate = null;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.createType === 1) {
            var startAt = (new Date(this.ruleForm.startTime) * 1000) / 1000;
            if (this.ruleForm.validFrom == 1) {
              if (!startAt) {
                this.$message.error("请选择生效时间");
                return;
              }
              if (startAt < Date.now()) {
                // this.ruleForm.startTime = new Date();
                this.$message.error("当前生效时间已过期，请重新选择生效时间");
                return;
              }
            }
          }
          if (!this.ruleForm.fileName) {
            this.$message.error("请上传文件");
            return;
          }
          if (this.createType === 1) {
            if (!this.checkFileName()) return;
            this.analysis();
          } else {
            this.compare();
          }
        } else {
          return false;
        }
      });
    },
    async analysis() {
      this.$store.commit("setPageLoading", true);
      const res = await analysis({
        vendorId: this.id,
        categoryType: this.ruleForm.categoryType,
        fileName: this.ruleForm.fileName.split("/").pop(),
      });
      this.$store.commit("setPageLoading", false);
      console.log(res);
      res.data && (this.analyUrl = res.data);
      if (res.success) {
        this.innerSuccessVisible = true;
      } else if (res.success == false && !res.data) {
        this.$message.error(`${res.message}`);
        this.upFiles = [];
        this.$refs.upload.clearFiles();
      } else {
        this.upFiles = [];
        this.$refs.upload.clearFiles();
        this.innerFailedVisible = true;
      }
    },
    async compare() {
      this.$store.commit("setPageLoading", true);
      const newObj = {
        vendorId: this.id,
        categoryType: this.ruleForm.categoryType,
        seasonCode: this.ruleForm.seasonCode.value,
        coFlag: this.ruleForm.seasonCode.coFlag,
        fileName: this.ruleForm.fileName.split("/").pop(),
      };
      const res = await compare(newObj);
      this.$store.commit("setPageLoading", false);
      if(res.success){
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.1)'
        });
        this.intervalTimer(res.data);
      }else{
        this.loading.close();
        this.$message.error(res.message)
      }
      // this.compareResult.code = res.code;
      // this.compareResult.success = res.success;
      // this.compareResult.message = res.message;
      // this.compareResult.analyUrl = res.data.compareResultFileUrl;
      // this.compareResult.warmingPercentage = res.data.warmingPercentage
      // this.createDialogVisible2 = false;
      // this.createDialogVisible3 = true;
      // this.repeatSubmit = false;
      // this.fullscreenLoading = false;
    },
    intervalTimer(taskId) {
      this.timer = setInterval(() => {
          this.compareResultT(taskId);
        }, 1000);
    },
    async compareResultT(taskId){
      const res = await compareResult({taskId});
      if (res.data && (res.data.compareResult == 1 || res.data.compareResult == 2)){
        this.loading.close();
        clearInterval(this.timer);
        this.compareResult.code = res.code;
        this.compareResult.compareFailReason = res.data.compareFailReason || null;
        this.compareResult.success = res.success && res.data.compareResult == 1 ? true : false;
        this.compareResult.message = res.message;
        this.compareResult.analyUrl = res.data.compareResultFileUrl;
        this.compareResult.warmingPercentage = res.data.warmingPercentage
        this.createDialogVisible2 = false;
        this.createDialogVisible3 = true;
        this.repeatSubmit = false;
      }
    },
    createNextStep3() {
      this.createDialogVisible3 = false;
      this.createDialogVisible4 = true;
    },
    async submitCompare() {
      this.$refs.ruleForm4.validate(async (valid) => {
        if (!valid) {
          this.$message("请完善信息");
          return;
        }
        if (this.ruleForm.nextValidDate) {
          var nextValidDate =
            (new Date(this.ruleForm.nextValidDate) * 1000) / 1000;
          var minDate =
            this.ruleForm.validFrom == 1
              ? (new Date(this.ruleForm.startTime) * 1000) / 1000
              : Date.now();
          if (nextValidDate < minDate + 1 * 24 * 3600 * 1000) {
            this.$message.error("失效时间必须晚于生效时间至少一天");
            return;
          }
        }
        const startAt = (new Date(this.ruleForm.startTime) * 1000) / 1000;
        const newObj = {
          vendorId: this.id,
          priceChangeRuleId: this.ruleForm.priceChangeRuleId,
          categoryType: this.ruleForm.categoryType,
          seasonCodeList: this.ruleForm.seasonCodeList.map((item) => ({
            coFlag: item.coFlag,
            seasonCode: item.value,
          })),
          validFrom: this.ruleForm.validFrom == 1 ? startAt : 0,
          nextValidDate: this.ruleForm.nextValidDate
            ? (new Date(this.ruleForm.nextValidDate) * 1000) / 1000
            : null,
          fileName: this.ruleForm.fileName.split("/").pop(),
          seasonCode: this.ruleForm.seasonCode.value,
          coFlag: this.ruleForm.seasonCode.coFlag,
        };
        if (!this.checkFileName()) return;
        this.$store.commit("setPageLoading", true);
        const res = await ruleCreate(newObj);
        this.$store.commit("setPageLoading", false);
        if (res.success) {
          this.$message.success(`${res.message}`);
          this.createDialogVisible4 = false;
          this.resetQuery();
        } else if (res.code == 2001 && res.data && res.data.length) {
          let seasonList = res.data.map(item => {
                let coFlagStr =
                item.coFlag == 1
                  ? "(CO)"
                  : "";
                return item.seasonCode + coFlagStr;
              })
          let seasonStr = seasonList.join("、");
          this.$message.error(
            seasonStr + "季节没有生效中折扣，无法设置失效时间"
          );
        } else {
          this.$message.error(`${res.message}`);
        }
      });
    },
    async submitFile() {
      const startAt = (new Date(this.ruleForm.startTime) * 1000) / 1000;
      const newObj = {
        vendorId: this.id,
        priceChangeRuleId: this.ruleForm.priceChangeRuleId,
        categoryType: this.ruleForm.categoryType,
        seasonCodeList: this.ruleForm.seasonCodeList.map((item) => ({
          coFlag: item.coFlag,
          seasonCode: item.value,
        })),
        validFrom: this.ruleForm.validFrom == 1 ? startAt : 0,
        fileName: this.ruleForm.fileName.split("/").pop(),
      };
      this.$store.commit("setPageLoading", true);
      const res = await ruleCreate(newObj);
      this.$store.commit("setPageLoading", false);
      if (res.success) {
        this.$message.success(`${res.message}`);
        this.createDialogVisible2 = false;
        this.innerSuccessVisible = false;
        this.ruleForm = {
          categoryType: "1",
          validFrom: null,
          startTime: null,
          seasonCodeList: [],
          seasonCode: null,
          fileName: "",
        };
        this.resetQuery();
      } else {
        this.$message.error(`${res.message}`);
      }
    },
    submitForm1(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          var startAt = (new Date(this.ruleForm1.startTime) * 1000) / 1000;
          if (this.ruleForm1.validFrom == 1) {
            if (!startAt) {
              this.$message.error("请选择生效时间");
              return;
            }
            if (startAt < Date.now()) {
              // this.ruleForm.startTime = new Date();
              this.$message.error("当前生效时间已过期，请重新选择生效时间");
              return;
            }
          }
          if (this.ruleForm1.nextValidDate) {
            var nextValidDate =
              (new Date(this.ruleForm1.nextValidDate) * 1000) / 1000;
            var minDate =
              this.ruleForm1.validFrom == 1
                ? (new Date(this.ruleForm1.startTime) * 1000) / 1000
                : Date.now();
            if (nextValidDate < minDate + 1 * 24 * 3600 * 1000) {
              this.$message.error("失效时间必须晚于生效时间至少一天");
              return;
            }
          }

          this.$store.commit("setPageLoading", true);
          const res = await ruleUpdate({
            vendorId: this.id,
            priceChangeRuleId: this.ruleForm1.priceChangeRuleId,
            validFrom: this.ruleForm1.validFrom == 1 ? startAt : 0,
            nextValidDate: this.ruleForm1.nextValidDate
              ? (new Date(this.ruleForm1.nextValidDate) * 1000) / 1000
              : null,
          });
          this.$store.commit("setPageLoading", false);
          if (res.success) {
            this.$message.success("提交成功");
            this.dialogVisible1 = false;
            this.resetQuery();
          } else if (res.code == 2001 && res.data && res.data.length) {
            this.$message.error("当前季节没有生效中折扣，无法设置失效时间");
          } else {
            this.$message.error(`${res.message}`);
          }
        } else {
        }
      });
    },
    submitForm2(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          var startAt = (new Date(this.ruleForm2.startTime) * 1000) / 1000;
          if (this.ruleForm2.validFrom == 1) {
            if (!startAt) {
              this.$message.error("请选择生效时间");
              return;
            }
            if (startAt < Date.now()) {
              // this.ruleForm.startTime = new Date();
              this.$message.error("当前生效时间已过期，请重新选择生效时间");
              return;
            }
          }
          if (this.ruleForm2.nextValidDate) {
            var nextValidDate =
              (new Date(this.ruleForm2.nextValidDate) * 1000) / 1000;
            var minDate =
              this.ruleForm2.validFrom == 1
                ? (new Date(this.ruleForm2.startTime) * 1000) / 1000
                : Date.now();
            if (nextValidDate < minDate + 1 * 24 * 3600 * 1000) {
              this.$message.error("失效时间必须晚于生效时间至少一天");
              return;
            }
          }

          const newObj = {
            vendorId: this.id,
            priceChangeRuleId: this.ruleForm2.priceChangeRuleId,
            categoryType: this.ruleForm2.categoryType,
            seasonCodeList: this.ruleForm2.seasonCodeList.map((item) => ({
              coFlag: item.coFlag,
              seasonCode: item.value,
            })),
            validFrom: this.ruleForm2.validFrom == 1 ? startAt : 0,
            nextValidDate: this.ruleForm2.nextValidDate
              ? (new Date(this.ruleForm2.nextValidDate) * 1000) / 1000
              : null,
          };
          try {
            this.$store.commit("setPageLoading", true);
            const res = await ruleCopy(newObj);
            this.$store.commit("setPageLoading", false);
            if (res.success) {
              this.$message.success(`${res.message}`);
              this.dialogVisible2 = false;
              this.ruleForm2 = {
                categoryType: "",
                seasonCodeList: [],
                seasonCode: null,
                coFlag: null,
                priceChangeRuleId: "",
                validFrom: null,
                startTime: null,
              };
              this.resetQuery();
              this.$store.commit("setPageLoading", false);
            } else if (res.code == 2001 && res.data && res.data.length) {
              let seasonList = res.data.map(item => {
                let coFlagStr =
                item.coFlag == 1
                  ? "(CO)"
                  : "";
                return item.seasonCode + coFlagStr;
              })
              let seasonStr = seasonList.join("、");
              this.$message.error(
                seasonStr + "季节没有生效中折扣，无法设置失效时间"
              );
            } else {
              this.$message.error(`${res.message}`);
            }
          } catch (error) {
            this.$store.commit("setPageLoading", false);
          }
        } else {
          return false;
        }
      });
    },
    resetQuery() {
      this.currentPage = 1;
      this.getTableData(this.form);
      this.$parent.init();
    },
    async getTableData(data) {
      if (data.isReset) {
        this.currentPage = 1;
      }
      let targetObj = {
        vendorId: this.id,
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      Object.assign(targetObj, this.form, data);
      this.$store.commit("setPageLoading", true);
      // 记录上次搜索的数据
      this.lastSearchData = targetObj;
      let resData = (await diaryDisountList(targetObj)).data;
      data.isReset = false;
      this.form = data;
      let { total, list } = resData;
      this.total = total;
      this.tableData = list;
      this.$store.commit("setPageLoading", false);
    },
    handle(num) {
      if (num) {
        var startAt =
          (new Date(this[`ruleForm${num}`].startTime) * 1000) / 1000;
        if (startAt < Date.now()) {
          this[`ruleForm${num}`].startTime = new Date();
        }
      } else {
        var startAt = (new Date(this.ruleForm.startTime) * 1000) / 1000;
        if (startAt < Date.now()) {
          this.ruleForm.startTime = new Date();
        }
      }
    },
    handleNext(num) {
      if (num) {
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData(this.form);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData(this.form);
    },
    async downloadFile() {
      let resData = await getTemplateUrl(this.ruleForm.categoryType, this.id);
      if (resData.data && resData.data.data) {
        downloadUrlFile(resData.data.data);
      }
    },
    downModel(blob, fileName) {
      if ("download" in document.createElement("a")) {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } else {
        navigator.msSaveBlob(blob, fileName);
      }
    },
    random_string(len) {
      len = len || 32;
      let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678",
        maxPos = chars.length,
        pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    getDate() {
      const date = new Date(),
        year = date.getFullYear(),
        month =
          date.getMonth() > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`,
        day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`,
        hh = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`,
        mm =
          date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
      return `${year}${month}${day}${hh}${mm}`;
    },
    downloadUrlFile(url) {
      downloadUrlFile(url);
    },
    showSkuForm(){
      let routeData = this.$router.resolve({
        path: '/discount/daily/sku',
        query: {
          vendorId: this.$route.query.id,
        }
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.flex {
  height: 80px;
  padding-top: 13px;
  padding-left: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}
.absolute {
  position: absolute;
  top: 0;
  left: 168px;
}
.big {
  font-family: "PingFang SC Bold", "PingFang SC";
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  text-align: center;
  line-height: 32px;
}
.f14 {
  font-size: 14px;
}
.tc {
  text-align: center;
}
.primary {
  color: #409eff;
}
.green {
  color: #008000;
}
.red {
  color: red;
}
.mt10 {
  margin-top: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.ml20 {
  margin-left: 20px;
}
.el-upload__tip {
  line-height: 1.2;
}
</style>
<style lang="less">
.myTable {
  thead th {
    color: #000;
  }
}
</style>
